import { Link } from "react-router-dom";
import { Logo } from "../Logo";

export function PublicFooter() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="mb-4">
              <Logo size="sm" variant="on-dark" href="/" />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed max-w-xs">
              The AI ordering engine for modern restaurants. Provide your customers with
              a seamless ordering experience across any platform — website, app, or chat.
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="inline-flex items-center gap-1.5 text-xs text-gray-500 bg-gray-800 border border-gray-700 rounded-full px-3 py-1">
                <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse" />
                All systems operational
              </span>
            </div>
          </div>

          {/* Product */}
          <div>
            <p className="text-gray-200 font-semibold text-sm mb-4">Product</p>
            <ul className="space-y-2.5">
              {[
                { to: "/plans", label: "Pricing & Plans" },
                { to: "/guides", label: "Guides" },
                { to: "/demo", label: "Live Demo" },
                { to: "/contact", label: "Contact Sales" },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="text-gray-400 hover:text-gray-200 text-sm transition-colors"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Features */}
          <div>
            <p className="text-gray-200 font-semibold text-sm mb-4">Features</p>
            <ul className="space-y-2.5">
              {[
                "AI Ordering Bot",
                "Owner Dashboard",
                "Menu Management",
                "Order Approval Flow",
                "Multi-Staff Access",
              ].map((item) => (
                <li key={item} className="text-gray-500 text-sm">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-600 text-xs">
            © {new Date().getFullYear()} Cravbot. All rights reserved.
          </p>
          <p className="text-gray-700 text-xs">
            Built for restaurants that demand more.
          </p>
        </div>
      </div>
    </footer>
  );
}
